import { Component, OnInit } from '@angular/core';

// services
import { DeviceService } from '@open-portal-app/device/services/device.service';

@Component({
  selector: 'device-validation',
  templateUrl: './device-validation.component.html',
  styleUrls: ['./device-validation.component.scss']
})
export class DeviceValidationComponent implements OnInit {

  constructor(
    private deviceService: DeviceService
  ) { }

  ngOnInit(): void {
    // Mobile check
    const mobile = this.deviceService.isMobile(navigator.userAgent);
    this.deviceService.setDeviceDataAttribute('isMobile', mobile)

    // OS check
    // iOS
    const isIphone = this.deviceService.isIphone(navigator.userAgent);
    if (isIphone) this.deviceService.setDeviceDataAttribute('OS', 'iPhone');
    // Android
    const android = this.deviceService.isAndroid(navigator.userAgent);
    if (android) this.deviceService.setDeviceDataAttribute('OS', 'Android');

    // Get device ID
    const deviceId = this.deviceService.getDevice(navigator.userAgent);
    this.deviceService.setDeviceDataAttribute('deviceId', deviceId);
  }
}